import { render } from "./CrudLicenca.vue?vue&type=template&id=6510b375&scoped=true"
import script from "./CrudLicenca.vue?vue&type=script&lang=ts"
export * from "./CrudLicenca.vue?vue&type=script&lang=ts"

import "./CrudLicenca.vue?vue&type=style&index=0&id=6510b375&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6510b375"

export default script